// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InputPhone[data-v-68e8e966]{border:var(--input-border);height:var(--input-height);padding:0 0;border-radius:var(--input-radius);width:100%;min-width:0px}.InputPhone[data-v-68e8e966]:focus-within{border-color:var(--input-focus-border-color);box-shadow:var(--input-focus-shadow)}.InputPhone.is-error[data-v-68e8e966]{border-color:var(--input-error-border-color)}.validation-check[data-v-68e8e966]{position:absolute;top:50%;right:1rem;transform:translateY(-50%)}\n", ""]);
// Exports
module.exports = exports;
